
function calculatorNode(item, idx) {
	
	let node = {
			id: `${item.id}-${idx}-node`,
			name: item.prompt,
		},
		slots = [{
			id: `${item.id}${idx}`.padEnd(64, '0'),
			type: "numeric",
			kind: "static",
			reference: "calculator",
			label: item.prompt,
		}],
		block = {
			type: "@tripetto/block-calculator",
			version: "4.0.6",
			operations: [],
		},
		textblock = {
			id: `${item.id}${idx}-text`.padEnd(64, '0'),
			name: `${item.prompt} Score: @${slots[0].id}`,
			nameVisible: true
		};

	if (item.operations !== undefined && item.operations.length > 0) {

		let operations = item.operations
			.map((c) => {
				let ops = {...c};
				if (ops.opcode_value === '') {
					ops.opcode_value = c.label;
				}

				if (ops.opcode === "score"){
					ops.itemScores = Object.fromEntries(ops.scores.map(({item: childItem, value: childVal
					}) => [`${ops.opcode_value}-0-choice-${childItem}`, childVal ?? childItem]))

					ops.opcode_value = `${ops.opcode_value}0`.padEnd(64, '0')
				}

				return {
					id: `${item.id}-0-choice-${ops.opcode_value}`,
					operator: ops.operator,
					opcode: ops.opcode,
					value: ops.opcode_value,
					...(ops.hasOwnProperty("itemScores") && ops.itemScores && {scores: ops.itemScores})
				}
			});
		
		for (let o of operations) {
			block.operations.push({
				id: o.id,
				operator: o.operator,
				opcode: o.opcode,
				value: o.value,
				...(o.opcode == "score" && {scores: o.scores})
			});
		}
	}

	return item.hasOwnProperty("showScore") && item.showScore 
		? [{
			...node,
			slots,
			block
			}, 
			textblock] 
		: [{
			...node,
			slots,
			block
		}];
}

export default calculatorNode;